import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createTextVNode(" Loaded ")),
    _createVNode(_component_v_text_field, {
      label: "Fichier",
      modelValue: _ctx.fileName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileName) = $event)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.inputUpload.click())),
      "prepend-icon": "mdi-attach-file",
      style: {"width":"100%","margin-right":"auto","margin-left":"auto"},
      density: "compact"
    }, null, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("input", {
      ref: "inputUpload",
      type: "file",
      accept: ".pdf",
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
    }, null, 544), [
      [_vShow, false]
    ]),
    (_ctx.document)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createTextVNode(" Date: " + _toDisplayString(_ctx.document.date), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createTextVNode(" TTC: " + _toDisplayString(_ctx.document.netAmount) + " | HT: " + _toDisplayString(_ctx.document.grossAmount) + " | TVA: " + _toDisplayString(_ctx.document.vatAmount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createTextVNode(" Name: " + _toDisplayString(_ctx.document.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createTextVNode(" Type: " + _toDisplayString(_ctx.document.type), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createTextVNode(" Company: " + _toDisplayString(_ctx.document.seller ? _ctx.document.seller.name : null), 1)
              ]),
              _: 1
            }),
            (_ctx.document && _ctx.document.multiVats)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.document.multiVats, (line, index) => {
                      return (_openBlock(), _createBlock(_component_v_row, {
                        key: index,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(line.vatAmount), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(line.vatRate), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(line.grossAmount), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(line.category || (line.vatRate === 0 ? "Pas défini" : null)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}